// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MGjtZ","issueWrapper":"styles_issueWrapper__wZzUg","feedbackWrapper":"styles_feedbackWrapper__U51qf"};